import React, { useState } from "react";
import { useLanguage } from "../Translations/LenguageContext";
import { useNavigate } from "react-router-dom";
import { MdTune } from "react-icons/md";
import { BiPlus } from "react-icons/bi";
import { RiSeoLine } from "react-icons/ri";
import { BsBarChart } from "react-icons/bs";

const MainAds = ({
    account_id
}) => {
    const { t } = useLanguage()
    const navigate = useNavigate()
    const [openModal, setOpenModal] = useState(false)
    const [data, setData] = useState([])

    const fetchRecords = async () => {

    }

    return (
        <div className="mainframe_item" >
            <div className="mainframe_item_header" >
                <p className="mainframe_item_title fade-in">{t.ads.title}</p>
                <div className="mainframe_item_subtitle fade-in">
                    {data.length === 0 ? (
                        <div className="empty_org_mex_cont">
                            <p>{t.ads.empty_subtitle}</p>
                            <div className="empty_org_img">
                                <p className="empty_org_img_title">
                                    <i><BsBarChart /></i> {t.ads.quest_title}
                                </p>
                                <p className="empty_org_img_subtitle">{t.ads.quest_answ}</p>
                            </div>
                        </div>
                    ) : (
                        <p>{t.ads.subtitle}</p>
                    )}
                </div>
                <button
                    className={`mainframe_item_create_btn fade-in ${data.length === 0 && "mainframe_item_create_btn_anim"}`}
                    onClick={() => setOpenModal(true)}
                >
                    <BiPlus /> {t.create}
                </button>

            </div>
           
        </div >
    )
}

export default MainAds